import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "./wrapper";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";
import { switchToLevel } from "../ai-first/helpers";

// the demo account needs a data file named "rainfall" (Month,Rainfall columns)
const chartDemo = "title: Rainfall through the year\nchart: rainfall";

const chartsTour: StepType[] = [
	{
		selector: ".author-root",
		position: "center",
		content: () => (
			<TourStepContent description={() => <strong>{text.tourSteps.chartsTitle}</strong>} />
		),
		action: () => {
			switchToLevel(3);
			fireClearCodeEvent();
		},
	},
	{
		selector: "#action-control-files",
		content: () => (
			<TourStepContent description={() => text.tourSteps.chartsUploadedUnderFiles} />
		),
		actionAfter: () => {
			const toggleFiles = document.getElementById("action-control-files");
			toggleFiles?.click();
			// show the Data tab, where spreadsheets live
			setTimeout(() => {
				document.getElementById("file-tab-data")?.click();
			}, 150);
		},
	},
	{
		selector: "#file-uploader",
		content: () => (
			<TourStepContent description={() => text.tourSteps.chartsDataTab} />
		),
		actionAfter: () => {
			const toggleFiles = document.getElementById("action-control-files");
			toggleFiles?.click();
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.chartsAddChartPrefix}{" "}
						<span className="qp-tour-modifier">chart:</span>{" "}
						{text.tourSteps.chartsAddChartSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			typeSomeText({ text: "" });
			setTimeout(() => {
				fireClearCodeEvent();
				typeSomeText({ text: "chart: ", openAutoComplete: true });
			}, 150);
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent description={() => text.tourSteps.chartsRendered} />
		),
		action: () => {
			typeSomeText({ text: "" });
			setTimeout(() => {
				fireClearCodeEvent();
				typeSomeText({ text: chartDemo });
			}, 150);
		},
	},
];

export default chartsTour;
